import { useAutoScrollTop } from "app/custom-hooks/useAutoScrollTop";
import type { FC } from "react";
import CustomGroupWizardContainer from "app/pages/conversion/wizard/CustomGroupWizardContainer";

export const ConversionWizard: FC = () => {
    const autoScrollRef = useAutoScrollTop();
    return (
        <div
            className="sw-layout-scrollable-element use-sticky-css-rendering"
            ref={autoScrollRef}
        >
            <CustomGroupWizardContainer />
        </div>
    );
};
